import _ from "lodash";


let routeSchedules = {
    'MA': 'Monday-A',
    'MB': 'Monday-B',
    'TUA': 'Tuesday-A',
    'TUAN': 'Tuesday-A',
    'TUB': 'Tuesday-B',
    'TUBN': 'Tuesday-B',
    'WA': 'Wednesday-A',
    'WAN': 'Wednesday-A',
    'WB': 'Wednesday-B',
    'WBN': 'Wednesday-B',
    'THA': 'Thursday-A',
    'THAN': 'Thursday-A',
    'THB': 'Thursday-B',
    'THBN': 'Thursday-B',
    'FA': 'Friday-A',
    'FAN': 'Friday-A',
    'FB': 'Friday-B',
    'FBN': 'Friday-B'
  }


function BackToStart(){
    window.location.reload()
}

function ExitForm(){
    window.close();
}

function MakeCollectionsPretty(allBins){
    let bins = allBins.split(",");
    
    let prettyBins = <>
        {Object.entries(bins).map(([key, value]) => {
            return (<>
                    {value.trim() == "Recycling" &&
                        <span  className="bin-entry" style={{color: "green"}}>Recycling&nbsp;<i class="fa fa-recycle"></i></span>
                    }
                    {value.trim() == "food bin" &&
                        <span className="bin-entry" style={{color: "green"}}>Food&nbsp;<i class="fa fa-utensils"></i></span>
                    }
                    {value.trim() == "black bin" &&
                        <span className="bin-entry" >Black&nbsp;<i class="fa fa-trash"></i></span>
                    }
                    {value.trim() == "garden waste" &&
                        <span className="bin-entry" style={{color: "green"}}>Garden&nbsp;<i class="fa fa-trash"></i></span>
                    }
                </>      
            );
        })}
    </> 

    return prettyBins;
}


function GWCollectionResults({  D365Subs, wasteCollections, D365SubsError, collectionRetreived, routeCode, prevFormStep }) {

    let routePDFURL = `https://beta-edit.southglos.gov.uk/wp-content/uploads/${routeSchedules[routeCode]}.pdf`;

    return (
        <div>

            {collectionRetreived && 
                <div id="nextCollection">
                    <div className="highlight">
                        <a style={{"textDecoration" : "underline", "cursor" : "pointer"}}  onClick={prevFormStep} >
                            <svg style={{"transform" : "rotate(180deg)",  "cursor" : "pointer" }} xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><g fill='none' fill-rule='evenodd'><path fill='#00709E' fill-rule='nonzero' d='M8.371 7l-4.527 4.244a.955.955 0 0 0 .002 1.413c.42.393 1.09.391 1.506.002l5.284-4.954a.962.962 0 0 0 .311-.704.96.96 0 0 0-.311-.706L5.352 1.34a1.116 1.116 0 0 0-1.506.002.953.953 0 0 0-.002 1.413L8.37 7z'/></g></svg>
                            Back
                        </a>
  
                        <p style={{marginBottom: 12, marginTop: "10px"}}>Your next collection is:</p>
  
                        <div style={{"backgroundColor" : "white", padding: "25px"}}>
                            <p className="heading2">{ wasteCollections[0]["date_display"] }</p>
                            <p className="heading3" style={{marginBottom : "0px" } }>{wasteCollections[0]["text"]}</p>
                        </div>

                    </div>

                    <p style={{paddingTop: '1.25rem'}}>If you are on the soft plastics trial, put them out for collection on the same day as your other recycling. </p>

                    <h2>Collection calendar</h2>

                    <a href={routePDFURL} style={{textDecoration: 'underline' }} target="_parent" >View or print your collection calendar</a>
                    <br />
                    <br />
                </div>
            }

            {_.isEmpty(D365Subs) && 
                <div id="noGwSubsFounds">
                    <h2>Garden waste subscriptions</h2>
                    <p>No garden waste subscriptions were found.</p>
                    <a style={{textDecoration: 'underline' }}  href="https://www.southglos.gov.uk/form_newgreenwaste" target="_top" >Apply for a garden waste subscription</a>
                </div>
            }
            {
            /**@todo
             * Add check to not render table if getsubws/getsubd365 AND d365down
             */
            D365Subs.length > 0 &&
                <>
                    <h2>Garden waste subscriptions</h2>

                    <table className="table table-bordered" style={{marginBottom: 0}}>
                        <thead>
                        <tr>
                            <th>How many bins</th>
                            <th>Expiration date</th>
                            {/* <th>Renew subscription online</th> */}
                        </tr>
                        </thead>
                        <tbody>
                        {!D365SubsError &&
                            Object.entries(D365Subs).map(([key, value]) => {
                                return (
                                    <tr className="d365-entry">
                                    <td>{value["BinsSubscribed"]}</td>
                                    <td>{value["ExpiryDate"]}</td>
                                    {/* <td><a href="https://www.southglos.gov.uk/form_renewgreenwaste" target="_top" >Renew online</a></td> */}
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </>
            }

            {/* <button type="button" className="button button--blue button__small"  onClick={BackToStart} >Restart</button> */}
            
            <br/>
            <br/>
            {/* <a style={{"textDecoration" : "underline" }}  onClick={BackToStart} >Start again</a> */}

            <button type="button" className="button button--close"  onClick={ExitForm}  >Close</button>

            <br/>
            <br/>

      </div>
    );

}

export default GWCollectionResults;